/**
 * #140539 — AC3: bấm link sâu từ Telegram khi CHƯA đăng nhập thì đăng nhập xong phải quay lại
 * ĐÚNG trang + ĐỦ params, không bị đá về trang chủ.
 *
 * VÌ SAO ĐI QUA URL (`?next=`) CHỨ KHÔNG DÙNG `state` CỦA REACT-ROUTER:
 * `AuthProvider.js` trước đây *có* lưu `state={{ from: location }}`, nhưng `LoginPage.js` đăng
 * nhập xong lại chạy `window.location.href = '/'` — vừa bỏ qua `from`, vừa TẢI LẠI CẢ TRANG nên
 * state trong bộ nhớ của react-router bị xoá sạch. Sửa mà vẫn dựa vào `state` là sửa hụt: test
 * xanh trên máy nhưng hỏng thật khi trang được tải lại (khuôn KHUON-LINK-SAU-THONG-BAO mục 3.1).
 */

export const NEXT_PARAM = 'next';

/** Trang mặc định khi không có `next` hợp lệ — giữ nguyên hành vi cũ. */
export const DEFAULT_AFTER_LOGIN = '/';

/**
 * Kiểm `next` có phải đường dẫn tương đối CÙNG NGUỒN không.
 *
 * CHỐNG OPEN-REDIRECT (bắt buộc, khuôn mục 3.1.4): thiếu bước này là tự mở lỗ lừa đảo — kẻ tấn
 * công gửi `/login?next=https://site-gia` để cướp phiên ngay sau khi người dùng đăng nhập.
 * Chỉ nhận giá trị bắt đầu bằng đúng MỘT dấu `/`; từ chối `http://`, `https://`, `//`, mọi thứ
 * có `\` (trình duyệt coi `\` như `/`, nên `/\evil.com` là link ra ngoài), mọi thứ có `:` trong
 * phần path (scheme kiểu `javascript:`), và mọi ký tự điều khiển.
 *
 * @param {unknown} value giá trị `next` ĐÃ được giải mã (URLSearchParams.get tự giải mã 1 lần)
 * @returns {boolean}
 */
export const isSafeNext = (value) => {
  if (typeof value !== 'string') return false;

  const raw = value.trim();
  if (!raw) return false;

  // Ký tự điều khiển (kể cả \n, \t, NUL) — hay dùng để lách bộ lọc.
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(raw)) return false;

  if (raw.includes('\\')) return false;
  if (raw.startsWith('//')) return false;
  if (!raw.startsWith('/')) return false;

  // `:` trong query là hợp lệ (vd `?t=12:30`), nhưng trong path thì chỉ có thể là scheme trá
  // hình — chỉ soi phần path.
  const pathOnly = raw.split(/[?#]/)[0];
  if (pathOnly.includes(':')) return false;

  return true;
};

/**
 * Đường dẫn để quay lại sau khi đăng nhập. Không hợp lệ → trang mặc định (KHÔNG ra ngoài).
 * @param {string|URLSearchParams|null} [search] chuỗi query của `/login`, vd `?next=%2Femployees`
 * @returns {string}
 */
export const readNext = (search) => {
  const params =
    search instanceof URLSearchParams
      ? search
      : new URLSearchParams(
          typeof search === 'string'
            ? search
            : typeof window === 'undefined'
              ? ''
              : window.location.search,
        );

  const value = params.get(NEXT_PARAM);
  return isSafeNext(value) ? value : DEFAULT_AFTER_LOGIN;
};

/**
 * Dựng URL trang đăng nhập giữ lại nơi người dùng ĐỊNH VÀO (đủ cả path, query và hash).
 * @param {{pathname?: string, search?: string, hash?: string}} location
 * @returns {string} vd `/login?next=%2Femployees%3Fbranch_id%3Dbranch-1`
 */
export const buildLoginUrl = (location) => {
  const { pathname = '/', search = '', hash = '' } = location || {};
  const target = `${pathname}${search}${hash}`;

  // Đang ở sẵn trang mặc định thì không cần `next` — giữ URL đăng nhập sạch.
  if (!isSafeNext(target) || target === DEFAULT_AFTER_LOGIN) return '/login';

  return `/login?${NEXT_PARAM}=${encodeURIComponent(target)}`;
};
